// src/components/BackButton.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { CaretLeft } from "phosphor-react";

/**
 * Reusable back button.
 * - If `onClick` is provided, it will be called.
 * - Else if `to` is provided, navigates there (optionally with `replace`).
 * - Else falls back to `navigate(-1)`.
 */
export default function BackButton({
  onClick,
  to,
  replace = false,
  className = "",
  ariaLabel = "Back",
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (typeof onClick === "function") return onClick(e);
    if (to) return navigate(to, { replace });
    return navigate(-1);
  };

  return (
    <button
        type="button"
        onClick={handleClick}
        className={[
            "inline-flex items-center justify-center w-7 h-7 rounded-md",
            "text-lg leading-none text-gray-800",
            className,
        ].join(" ")}
        aria-label={ariaLabel}
    >
       <CaretLeft size={20} weight="bold" />  {/* or "fill" */}
    </button>

  );
}
